/* Somnair — add-to-cart behaviour for the two custom buy boxes.

   DEVICE main CTA (form.smp-atcform, "Start Your Transformation"):
     Adds the full bundle then OPENS THE CART DRAWER as a preview — the client
     reviews the 5 lines and taps "Check out" themself. It CLEARS the cart first
     so the drawer always shows exactly the 5-line offer at $109 — never a
     doubled bundle from a prior add — then posts ONE JSON {items:[device,
     4 bonuses]} to /cart/add.js WITH the Section Rendering keys
     (sections: cart-drawer,cart-icon-bubble) so the same response feeds
     drawer.renderContents(), which repaints the drawer + header bubble and
     opens it. Bonus variant ids come from the form's data-bundle-ids attribute,
     emitted by the buybox section only when all bonuses resolved & available.
     Without data-bundle-ids it falls back to the single-item FormData add.
     If the theme has no <cart-drawer> (cart_type != drawer) the old behaviour
     remains: add then redirect to /checkout. If the add fails it RE-CLEARS the
     cart (a multi add can fail halfway and a leftover paid bonus without its
     two siblings would be CHARGED — the 100% discount needs the 3 together,
     $97 min) then degrades to a native POST with return_to=/checkout (never
     /cart: that page renders invisible on this theme — Shrine license guard).

   PATCHES form (form.smpp-form): unchanged — AJAX add that opens the theme's
     cart drawer (re-order flow). Native /cart fallback.

   The cart drawer itself is still reachable from the header cart icon. */
(function () {
  'use strict';
  if (window.__somnairAtcBound) return;
  window.__somnairAtcBound = true;

  var CHECKOUT_URL = '/checkout';
  var CLEAR_URL = '/cart/clear.js';

  function addUrl() {
    return (window.routes && window.routes.cart_add_url) || '/cart/add';
  }

  document.addEventListener('submit', function (evt) {
    var form = evt.target && evt.target.closest
      ? evt.target.closest('form.smp-atcform, form.smpp-form')
      : null;
    if (!form || form.dataset.somnairNative === 'true') return;

    /* ---------- DEVICE main CTA: add bundle + open the cart drawer ---------- */
    if (form.classList.contains('smp-atcform')) {
      evt.preventDefault();

      var button = form.querySelector('[type="submit"]');
      var originalHtml = button ? button.innerHTML : null;
      if (button) { button.disabled = true; button.innerHTML = '…'; }
      var restoreBtn = function () {
        if (button) { button.disabled = false; button.innerHTML = originalHtml; }
      };

      var deviceDrawer = document.querySelector('cart-drawer');
      var canDrawer = !!(deviceDrawer && typeof deviceDrawer.renderContents === 'function');

      var deviceSectionIds = ['cart-drawer', 'cart-icon-bubble'];
      if (canDrawer) {
        try {
          if (typeof deviceDrawer.getSectionsToRender === 'function') {
            deviceSectionIds = deviceDrawer.getSectionsToRender().map(function (s) { return s.id; });
          }
        } catch (e) { /* keep defaults */ }
      }

      var nativeFallback = function () {
        // Degraded path: native POST with return_to=/checkout. NOT /cart —
        // this theme's /cart page renders invisible (Shrine license guard
        // keeps main{visibility:hidden}), a dead end for the client.
        if (!form.querySelector('input[name="return_to"]')) {
          var rt = document.createElement('input');
          rt.type = 'hidden';
          rt.name = 'return_to';
          rt.value = CHECKOUT_URL;
          form.appendChild(rt);
        }
        form.dataset.somnairNative = 'true';
        form.submit();
      };

      // Bundle payload. Cart lines list newest-first, so to DISPLAY
      // device → patches → warranty → string → shipping (SleepEase order) we
      // ADD in reverse: bonuses reversed first, device last.
      var deviceInput = form.querySelector('input[name="id"]');
      var deviceId = deviceInput ? parseInt(deviceInput.value, 10) : 0;
      var bonusItems = [];
      (form.dataset.bundleIds || '').split(',').forEach(function (raw) {
        var idNum = parseInt(raw, 10);
        if (idNum && idNum !== deviceId) bonusItems.push({ id: idNum, quantity: 1 });
      });
      var items = bonusItems.reverse();
      if (deviceId) items.push({ id: deviceId, quantity: 1 });

      var clearCart = function () {
        return fetch(CLEAR_URL, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      };
      var addItems = function () {
        if (deviceId && items.length > 1) {
          // 5-line bundle: one JSON add on the documented AJAX endpoint.
          var payload = { items: items };
          if (canDrawer) {
            payload.sections = deviceSectionIds;
            payload.sections_url = window.location.pathname;
          }
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(payload)
          });
        }
        // No bundle data (setting emptied / a bonus unavailable): single add.
        var body = new FormData(form);
        if (canDrawer) {
          body.append('sections', deviceSectionIds.join(','));
          body.append('sections_url', window.location.pathname);
        }
        return fetch(addUrl(), {
          method: 'POST',
          headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: body
        });
      };

      // Clear so the bundle can't stack, add the lines, then show the preview.
      clearCart()
        .then(addItems)
        .then(function (response) { return response.json(); })
        .then(function (response) {
          if (response.status) {
            // Shopify validation error (e.g. sold out) — surface it natively.
            throw new Error(response.description || response.message || 'ATC failed');
          }
          if (canDrawer) {
            if (typeof deviceDrawer.setActiveElement === 'function') {
              deviceDrawer.setActiveElement(document.activeElement);
            }
            deviceDrawer.classList.remove('is-empty');
            deviceDrawer.renderContents(response); // repaints drawer + bubble, then opens
            restoreBtn();
          } else {
            // Theme configured without a drawer: keep the converting path.
            window.location.href = CHECKOUT_URL;
          }
        })
        .catch(function () {
          // A multi add can fail halfway; an orphan paid bonus would be charged.
          // Re-clear before degrading to the native device-only POST.
          var degrade = function () {
            restoreBtn();
            nativeFallback();
          };
          clearCart().then(degrade, degrade);
        });
      return;
    }

    /* ---------- PATCHES form: AJAX add + open the cart drawer ---------- */
    var drawer = document.querySelector('cart-drawer');
    if (
      !drawer ||
      typeof drawer.renderContents !== 'function' ||
      !window.routes ||
      !window.routes.cart_add_url
    ) {
      return; // let the native POST proceed (lands on /cart)
    }

    evt.preventDefault();

    var pbutton = form.querySelector('[type="submit"]');
    var pOriginalHtml = pbutton ? pbutton.innerHTML : null;
    if (pbutton) { pbutton.disabled = true; pbutton.innerHTML = '…'; }
    var restore = function () {
      if (pbutton) { pbutton.disabled = false; pbutton.innerHTML = pOriginalHtml; }
    };

    var sectionIds = ['cart-drawer', 'cart-icon-bubble'];
    try {
      if (typeof drawer.getSectionsToRender === 'function') {
        sectionIds = drawer.getSectionsToRender().map(function (s) { return s.id; });
      }
    } catch (e) { /* keep defaults */ }

    var body = new FormData(form);
    body.append('sections', sectionIds.join(','));
    body.append('sections_url', window.location.pathname);

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (response) { return response.json(); })
      .then(function (response) {
        if (response.status) {
          throw new Error(response.description || response.message || 'ATC failed');
        }
        if (typeof drawer.setActiveElement === 'function') {
          drawer.setActiveElement(document.activeElement);
        }
        drawer.classList.remove('is-empty');
        drawer.renderContents(response);
        restore();
      })
      .catch(function () {
        restore();
        form.dataset.somnairNative = 'true';
        form.submit();
      });
  });
})();
